import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import "./TextArea.css";

export default class TextArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: (this.props.existingContent) ? this.props.existingContent : ""
    };
  }

  componentWillReceiveProps(newProps) {
    if ('existingContent' in newProps && newProps.existingContent !== undefined && newProps.existingContent !== this.state.value) {
      this.setState({ value: newProps.existingContent });
    }
  }

  getValue = () => {
    if (this.props.required && this.state.value === "") {
      throw new InputError(this.props.label + " is Required", this.state.value);
    }

    return this.state.value;
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value });

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  render () {
    let labelText = this.props.label;

    let label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {labelText}
      </label> :
      null;

    let errorMessage = (this.props.errorMessage) ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    let requiredFieldIndicator = (this.props.required) ?
      <abbr title="This field is required">*</abbr> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let readOnlyContent = (this.props.existingContent) ?
      this.props.existingContent.split("\n").map((paragraph, index) => {
        if (paragraph !== "") {
          return <p key={index}>{paragraph}</p>;
        }
        return null;
      }) :
      null;

    let textAreaDisplay = (this.props.isEditable) ?
      <span>
        {requiredFieldIndicator}{label}
        <textarea
          className={this.props.className}
          disabled={this.props.disabled}
          id={this.props.id}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          name={this.props.name}
          onChange={(e) => this.handleChange(e)}
          placeholder={this.props.placeholderText}
          required={this.props.required}
          value={this.state.value}
        >
        </textarea>
        {errorMessage}
      </span> :
      <span>
        {label}
        <div className="read-only">
          {readOnlyContent}
        </div>
      </span>;

    return (
      <div className={`${verticalSpacingClass} text-area`}>
        {textAreaDisplay}
      </div>
    );
  }
}

TextArea.defaultProps = {
  isEditable: true
};

TextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  existingContent: PropTypes.string,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.string,
  minLength: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  verticalSpacing: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/text-area/TextArea.js